module.exports = __webpack_public_path__ + "static/media/Manos3R.82684479.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Manos3R.png
// module id = 191
// module chunks = 0